'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AcceptedDrugRequestsIndicatorState(state) {
  this.Lapp_data_AcceptedDrugRequestsIndicatorState__f_state = null;
  this.Lapp_data_AcceptedDrugRequestsIndicatorState__f_state = state;
}
export { $c_Lapp_data_AcceptedDrugRequestsIndicatorState as $c_Lapp_data_AcceptedDrugRequestsIndicatorState };
$c_Lapp_data_AcceptedDrugRequestsIndicatorState.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AcceptedDrugRequestsIndicatorState.prototype.constructor = $c_Lapp_data_AcceptedDrugRequestsIndicatorState;
/** @constructor */
function $h_Lapp_data_AcceptedDrugRequestsIndicatorState() {
}
export { $h_Lapp_data_AcceptedDrugRequestsIndicatorState as $h_Lapp_data_AcceptedDrugRequestsIndicatorState };
$h_Lapp_data_AcceptedDrugRequestsIndicatorState.prototype = $c_Lapp_data_AcceptedDrugRequestsIndicatorState.prototype;
$c_Lapp_data_AcceptedDrugRequestsIndicatorState.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_AcceptedDrugRequestsIndicatorState.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1702790227, true);
});
$c_Lapp_data_AcceptedDrugRequestsIndicatorState.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AcceptedDrugRequestsIndicatorState)) {
    var x = this.Lapp_data_AcceptedDrugRequestsIndicatorState__f_state;
    var x$2 = x$0.Lapp_data_AcceptedDrugRequestsIndicatorState__f_state;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lapp_data_AcceptedDrugRequestsIndicatorState.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_AcceptedDrugRequestsIndicatorState.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_data_AcceptedDrugRequestsIndicatorState.prototype.productPrefix__T = (function() {
  return "AcceptedDrugRequestsIndicatorState";
});
$c_Lapp_data_AcceptedDrugRequestsIndicatorState.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_data_AcceptedDrugRequestsIndicatorState__f_state;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_AcceptedDrugRequestsIndicatorState.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "state";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_AcceptedDrugRequestsIndicatorState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_AcceptedDrugRequestsIndicatorState)));
}
export { $isArrayOf_Lapp_data_AcceptedDrugRequestsIndicatorState as $isArrayOf_Lapp_data_AcceptedDrugRequestsIndicatorState };
var $d_Lapp_data_AcceptedDrugRequestsIndicatorState = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AcceptedDrugRequestsIndicatorState, "app.data.AcceptedDrugRequestsIndicatorState", ({
  Lapp_data_AcceptedDrugRequestsIndicatorState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_data_AcceptedDrugRequestsIndicatorState as $d_Lapp_data_AcceptedDrugRequestsIndicatorState };
//# sourceMappingURL=app.data.-Accepted-Drug-Requests-Indicator-State.js.map
